export type PlannedRangeValue = [Date | null, Date | null] | null;

export type AnchorStopTimes = {
  plannedDeparture: Date | null;
  plannedArrival: Date | null;
};

function sameInstant(
  a: Date | null | undefined,
  b: Date | null | undefined,
): boolean {
  if (a == null && b == null) {
    return true;
  }
  if (a == null || b == null) {
    return false;
  }
  return a.getTime() === b.getTime();
}

export function plannedRangesEqual(
  a: PlannedRangeValue,
  b: PlannedRangeValue,
): boolean {
  if (a == null && b == null) {
    return true;
  }
  if (a == null || b == null) {
    return false;
  }
  return sameInstant(a[0], b[0]) && sameInstant(a[1], b[1]);
}

/** Pickup = first stop departure; delivery = last stop arrival. */
export function plannedRangeFromAnchorStops(
  stops: ReadonlyArray<AnchorStopTimes>,
): PlannedRangeValue {
  if (stops.length < 2) {
    return null;
  }
  const start = stops[0]!.plannedDeparture;
  const end = stops[stops.length - 1]!.plannedArrival;
  if (start == null && end == null) {
    return null;
  }
  return [start, end];
}

export function isPlannedRangeComplete(
  range: PlannedRangeValue | undefined,
): boolean {
  if (range == null) {
    return false;
  }
  const [start, end] = range;
  if (start == null || end == null) {
    return false;
  }
  return (
    !Number.isNaN(start.getTime()) && !Number.isNaN(end.getTime())
  );
}
